import React from 'react'
import SimpleBanner from '../../components/common/SimpleBanner'
import PortfolioPage from '../../components/User/Portfolio.jsx/Portfoliopage'

const Portfolio = () => {
  return (
    <div>
         <SimpleBanner   title = "Portfolio" subheading = "Home / Portfolio"/>
         <PortfolioPage/>
    </div>
  )
}

export default Portfolio